import { User } from 'domains/user';
import { UserDTO } from 'infrastructure/dtos/user';

export class UserMapper {
  public static fromDTO(this: void, dto: UserDTO): User {
    const role = dto.role ?? 'user';

    return new User(dto.id, dto.username, dto.email, role);
  }
}
